// extracted by mini-css-extract-plugin
export default {"outerContainer":"vAJXZ","sizing":"vj15e","double":"Nbp-P","imageContainer":"C-BR1","imageBackground":"_8OUF-","image":"iAA2W"};